import { render, staticRenderFns } from "./customer-invoices.vue?vue&type=template&id=0de68c9f&scoped=true&"
import script from "./customer-invoices.vue?vue&type=script&lang=js&"
export * from "./customer-invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de68c9f",
  null
  
)

export default component.exports